import Utils from 'src/utils';
import { ActionTypes } from 'src/store/actions/mainReportActions';
const initialState = {
    mainReport: [],
    completedWorkConfirmationsPending: false,
    completedWorkPending: false,
    completedWork: [],
    workDays: {},
    workDaysPending: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.REQUEST_COMPLETED_WORK_CONFIRMATIONS: {
            return {
                ...state,
                completedWorkConfirmationsExtendedPending: true
            };
        }
        case ActionTypes.FAILED_COMPLETED_WORK_CONFIRMATIONS: {
            return {
                ...state,
                completedWorkConfirmationsExtendedPending: false
            };
        }
        case ActionTypes.SAVE_NEW_COMPLETED_WORK_CONFIRMATION: {
            return {
                ...state,
                completedWorkConfirmationsExtendedPending: false,
                completedWork: insertCompletedWorkConfirmations({
                    completedWork: state.completedWork,
                    newConfirmations: payload
                })
            };
        }
        case ActionTypes.REMOVE_COMPLETED_WORK_CONFIRMATION: {
            return {
                ...state,
                completedWorkConfirmationsExtendedPending: false,
                completedWork: insertCompletedWorkConfirmations({
                    completedWork: state.completedWork,
                    newConfirmations: payload.response,
                    usersAffectedByRemove: payload.request.UserIds
                })
            };
        }
        case ActionTypes.REQUEST_COMPLETED_WORK: {
            return {
                ...state,
                completedWorkPending: true
            };
        }
        case ActionTypes.SAVE_COMPLETED_WORK: {
            return {
                ...state,
                completedWorkPending: false,
                completedWork: payload
            };
        }
        case ActionTypes.FAILED_COMPLETED_WORK: {
            return {
                ...state,
                completedWorkPending: false
            };
        }
        case ActionTypes.SAVE_MAIN_REPORT: {
            return {
                ...state,
                mainReport: payload.report,
                workDays: payload.workDays
            };
        }
        default: {
            return state;
        }
    }
};
const newConfirmationToMainReportFormat = (newConfirmation) => {
    return {
        Breaks: !!newConfirmation.ConfirmedWith?.Breaks,
        Lunches: !!newConfirmation.ConfirmedWith?.Lunches,
        SlipTimes: !!newConfirmation.ConfirmedWith?.SlipTimes,
        Levels: newConfirmation.ConfirmationLevel?.map((level) => ({
            Id: level.Id,
            Level: level.Level,
            Confirmer: {
                Id: level.User?.Id,
                Firstname: level.User?.Firstname,
                Lastname: level.User?.Lastname,
                ExternalCode: level.User?.ExternalCode
            },
            ConfirmerId: level.ConfirmerUserId,
            CreatedAt: level.CreatedAt
        }))
    };
};
function insertCompletedWorkConfirmations({ completedWork, newConfirmations, usersAffectedByRemove }) {
    const usersAffectedByRemoveSet = new Set(usersAffectedByRemove);
    const updates = Utils.arrays.arrayToMap('UserId', newConfirmations);
    const getConfirmations = (personId, existingConfirmations) => {
        if (updates.has(personId)) {
            return newConfirmationToMainReportFormat(updates.get(personId));
        }
        else if (usersAffectedByRemoveSet.has(personId) && !updates.has(personId)) {
            return null;
        }
        return existingConfirmations;
    };
    return completedWork.reduce((departmentsAcc, department) => {
        return [...departmentsAcc, {
                ...department,
                Persons: department.Persons?.reduce((personsAcc, person) => {
                    return [...personsAcc, {
                            ...person,
                            Confirmation: getConfirmations(person.Id, person.Confirmation)
                        }];
                }, [])
            }];
    }, []);
}
